var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 26,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 26,
  fill: "#DBDBDB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.7,
  d: "M10.616 21q-.673 0-1.144-.471A1.56 1.56 0 0 1 9 19.386V7H8V6h4v-.77h6V6h4v1h-1v12.386q0 .69-.462 1.152-.462.464-1.154.462zM20 7H10v12.386q0 .268.173.442a.6.6 0 0 0 .443.172h8.769a.6.6 0 0 0 .423-.192.58.58 0 0 0 .192-.424zm-7.192 11h1V9h-1zm3.384 0h1V9h-1z"
})));
export { SvgDeleteIcon as ReactComponent };
export default __webpack_public_path__ + "5757c2dd962940778863f5b7a2b061fe.svg";